import { assetsApi } from '@/api/assets'
import { uploadProductionAsset } from '@/api/studio-production'
import type { SilkAssetKind } from '@/api/types'

export function silkKindFromMime(mime: string): SilkAssetKind {
  if (mime.startsWith('image/')) return 'image'
  if (mime.startsWith('video/')) return 'video'
  if (mime.startsWith('audio/')) return 'audio'
  return 'other'
}

/** 画布落盘：自由创作走用户资产库，制片走项目资产库 */
export async function persistCanvasFile(opts: {
  isCreative: boolean
  productionId: string
  file: File
  productionKind?: string
}): Promise<{ url: string; publicId: string }> {
  if (opts.isCreative) {
    const asset = await assetsApi.upload(opts.file, silkKindFromMime(opts.file.type))
    if (!asset.url) throw new Error('missing asset url')
    return { url: asset.url, publicId: asset.public_id }
  }
  const asset = await uploadProductionAsset(opts.productionId, opts.file, {
    name: opts.file.name,
    kind: opts.productionKind,
  })
  const url = asset.media_url
  if (!url) throw new Error('missing asset url')
  return { url, publicId: asset.public_id }
}
